var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSelectedUsersIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.341,
    height: 16.923,
    viewBox: "0 0 24.341 16.923",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_191",
    "data-name": "Group 191",
    transform: "translate(-2437.06 -296.777)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_166",
    "data-name": "Path 166",
    d: "M2448.188,307.112h-5.935c-2.316,0-4.193,1.354-4.193,3.024l-1,3.564h16.32l-1-3.564C2452.38,308.466,2450.5,307.112,2448.188,307.112Z",
    fill: "#005637"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_22",
    "data-name": "Ellipse 22",
    cx: 3.78,
    cy: 3.78,
    r: 3.78,
    transform: "translate(2441.44 297.493)",
    fill: "#005637"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_167",
    "data-name": "Path 167",
    d: "M2456.93,305.344h-5.11a.734.734,0,0,0-.7.535l1.237.4a1.558,1.558,0,0,1,.976.926l1.456,3.811h6.611l-.861-3.068C2460.54,306.51,2458.924,305.344,2456.93,305.344Z",
    fill: "#005637"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_23",
    "data-name": "Ellipse 23",
    cx: 3.299,
    cy: 3.299,
    r: 3.299,
    transform: "translate(2451.672 296.777)",
    fill: "#005637"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedUsersIcon);
export default __webpack_public_path__ + "static/media/SelectedUsersIcon.0f4eb2bcc5d1af8ed2aa16bc2f251e2c.svg";
export { ForwardRef as ReactComponent };